import React from 'react';
import classnames from 'classnames';
import './index.scss';
export default (props) => {
    const { title = '', isFirst = false, children = [] } = props;
    return (React.createElement("div", { className: classnames('basic-info-title', { first: isFirst }) },
        title,
        children));
};
